var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 66,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.148 11.69C20.937 7.074 26.64 4.126 33 4.126c11.36 0 20.625 9.404 20.625 20.935 0 3.238-1.305 6.787-3.11 10.532-.974 2.03-2.107 4.107-3.313 6.152l-3.03-3.03a73.538 73.538 0 0 0 2.637-4.953c1.676-3.484 2.691-6.739 2.691-8.701 0-9.274-7.364-16.748-16.5-16.748-5.242 0-9.901 2.46-12.92 6.31l-2.932-2.931Zm-2.774 4.392a21.041 21.041 0 0 0-1.999 8.978c0 3.238 1.305 6.787 3.11 10.532 1.805 3.762 4.157 7.687 6.526 11.269 4.705 7.18 9.394 13.019 9.394 13.019L33 61.875l1.595-1.995s4.69-5.84 9.41-13.019l.454-.694-2.997-2.997c-.295.466-.592.928-.889 1.385-3.466 5.27-5.92 8.374-7.237 10.041l-.336.426-.336-.426c-1.317-1.666-3.771-4.771-7.237-10.041-2.272-3.5-4.56-7.294-6.236-10.794-1.676-3.484-2.691-6.739-2.691-8.701 0-2.052.36-4.016 1.021-5.83l-3.147-3.148Zm20.066 12.9-5.326-5.325c.57-1.62 2.098-2.784 3.886-2.784 2.272 0 4.125 1.88 4.125 4.187a4.196 4.196 0 0 1-2.685 3.923Z",
  fill: "#CCC"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 6.959,
  y: 14.667,
  width: 4.316,
  height: 57.867,
  rx: 2.158,
  transform: "rotate(-45 6.959 14.667)",
  fill: "#CCC"
})));
export default SvgNoLocation;